import React from "react";
import { Button } from "react-bootstrap";

import { useTranslation } from "react-i18next";

export default function DayClosureButton({ handler, disabled }) {
  const {
    t,
  } = useTranslation();

  return (
    <div className="float-right">
      <Button onClick={handler} size="md" className="text-warning btn-link edit" title={t("common.actions.dayClosure")} disabled={disabled}>
        <i className={disabled ? "nc-icon nc-money-coins icon-bold fa-spin" : "nc-icon nc-money-coins icon-bold"} />
      </Button>
    </div>
  );
}
